<template>
  <div class="feature-wrap style-three ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-in"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="feature-content">
            <div class="content-title style-one">
              <h6 class="section-subtitle" style="color: #9ca3af;">
                Unique Halal Mexican <span style="color: #e5e7eb;">Dining</span> Experience
              </h6>
              <h2 style="color: #b5ff00;">Franchise</h2>
              <p style="color: #e5e7eb; justify-content: center;">
              Offering a fast-casual dining experience that serves bowls, tacos, and quesadillas using only Zabiha halal meats and antibiotic-free produce. Signature dishes such as birria tacos, queso blanco, and churros provide authenticity and appeal. <br /> The concept directly addresses a significant gap in the fast-casual market: halal-certified Mexican cuisine. Traditional Mexican restaurants often include non-Halal proteins and alcohol, leaving Muslim and health-conscious diners underserved.
              </p>
            </div>
            <ul class="feature-list list-style">
              <li>Halal-Certified Mexican</li>
              <li>Fresh, Customizable Fast-Casual Experience</li>
              <li>Health-Conscious & Ethical Appeal</li>
            </ul>
          </div>
        </div>
        <div
          class="col-lg-6"
          data-aos="fade-in"
          data-aos-duration="1200"
          data-aos-delay="400"
        >
          <div class="feature-img">
            <img src="https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop" alt="Modern Restaurant Interior" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FranchiseHero",
});
</script>

<style lang="scss" scoped>
.feature-wrap {
  &.style-three {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1f1f1f 100%);
    .feature-content {
      .content-title {
        h2 {
          font-weight: 700;
          color: #ffffff;
        }
        h6 {
          color: #d1d5db;
          span {
            color: #9ca3af;
          }
        }
        p {
          color: #d1d5db;
        }
      }
      .feature-list {
        margin: 28px 0 0;
        li {
          background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
          color: #ffffff;
          font-size: 18px;
          font-weight: 500;
          position: relative;
          padding: 19px 20px 19px 62px;
          margin-bottom: 15px;
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          &:last-child {
            margin-bottom: 0;
          }
          &:before {
            position: absolute;
            top: 26px;
            left: 30px;
            content: "";
            width: 12px;
            height: 12px;
            background-color: #6b7280;
            border-radius: 50%;
          }
        }
      }
    }
    .feature-img {
      border-radius: 20px;
      display: block;
      margin-left: auto;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
      img {
        display: block;
        margin-left: auto;
        border-radius: 20px;
      }
    }
  }
}
</style>
